import React from 'react';
import './StoryReel.css';
import Story from './Story';

function StoryReel() {
	return (
		<div className='storyReel'>
			<Story
				image='https://www.quotemaster.org/images/7b/7b5b946d8d5fa9c7a02cbac19150a35a.jpeg'
				profileSrc='https://banner2.cleanpng.com/20180920/yko/kisspng-computer-icons-portable-network-graphics-avatar-ic-5ba3c66df14d32.3051789815374598219884.jpg'
				title='Rahul'
			/>

			<Story
				image='https://www.quotemaster.org/images/78/786e0444a20ab6f298cae47ba070e017.jpeg'
				profileSrc='https://png.pngtree.com/png-vector/20190321/ourmid/pngtree-vector-users-icon-png-image_856952.jpg'
				title='James'
			/>

			<Story
				image='https://www.quotemaster.org/images/96/96265235df3186a70f7ca32fb02bad58.jpeg'
				profileSrc='https://f0.pngfuel.com/png/348/800/man-wearing-blue-shirt-illustration-png-clip-art.png'
				title='Vlog'
			/>

			<Story
				image='https://i.pinimg.com/236x/53/8a/6a/538a6a1ddcab0beeaea0e8339ab65ee4--design-quotes-steve-jobs.jpg'
				profileSrc='https://cdn.iconscout.com/icon/free/png-512/avatar-369-456321.png'
				title='Sami'
			/>

			<Story
				image='https://media.images.yourquote.in/post/large/0/0/8/488/4dD15903.jpg'
				profileSrc='https://img.pngio.com/png-avatar-108-images-in-collection-page-3-png-avatar-300_300.png'
				title='Candy'
			/>

			<Story
				image='https://www.actismedia.co.uk/wp-content/uploads/2020/03/Centenary-GHS-Stamp-743x743x-Top-Offers.jpeg'
				profileSrc='https://img.pngio.com/avatar-business-face-people-icon-people-icon-png-512_512.png'
				title='Zonh'
			/>
		</div>
	);
}

export default StoryReel;
